import { gatewayInstance } from "../axiosInstance";
import { SERVICE_ENDPOINT } from "../const";

/**
 * Download Inspection Document API
 * @param {Object} payload - The data to be sent in the API request
 * @param {string} reportType - The type of report to generate (e.g., "pdf")
 * @returns {Promise<Blob>} - A Blob containing the generated report
 */
export const downloadGeneralReportDocument = async (
  payload,
  reportType = "pdf",
  reportName,
  url,
) => {
  try {
    const response = await gatewayInstance.post(
      `${SERVICE_ENDPOINT.REPORT}/report/inspection/generate`,
      payload,
      {
        responseType: "blob",
        params: {
          reportType,
          reportName,
          url,
        },
      }, // To handle binary PDF file responses
    );

    return response.data; // Return the Blob directly
  } catch (error) {
    console.error("Error downloading inspection document:", error);
    throw error;
  }
};

export const downloadInspectionReportDocument = async (tdhId) => {
  try {
    const response = await gatewayInstance.get(
      `${SERVICE_ENDPOINT.REPORT}/report/inspection/generate/by-id/${tdhId}`,
      {
        responseType: "blob",
      },
    );

    return response.data; // Return the Blob directly
  } catch (error) {
    console.error("Error downloading inspection document:", error);
    throw error;
  }
};
